/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStockonhandStocktakeboxCtrl
 */
angular.module('mercury.modules.stock.stockonhandreport')
.controller('StockStockonhandStocktakeboxCtrl', ["$scope", "reportLine", function($scope, reportLine) {
  $scope.itemName = reportLine.stockItemName;
  $scope.hasStocktake = reportLine.openingQtyStocktakeId != '00000000-0000-0000-0000-000000000000';
  $scope.stocktakeId = reportLine.openingQtyStocktakeId;
  $scope.stocktakeTitle = reportLine.openingQtyStocktakeTitle;
  $scope.openingQtyDate = moment(reportLine.openingQtyDate).format('DD MMM YYYY, h:mma');
  $scope.openingQty = reportLine.openingQty / reportLine.unit.ratio;
  $scope.unit = reportLine.unit.name;
}]);
